export default __webpack_public_path__ + "static/media/top-smoke.89342763.webp";